<mat-card class="p-0" >
    <mat-card-title >
      <div class="card-title-text"><small>{{title}}</small></div>
    </mat-card-title>
    <mat-card-content>
        <i class="fa fa-4x" [ngClass]="icon"></i>
        <h1 class="py-24">{{count}}</h1>
    </mat-card-content>
  </mat-card>